import { render } from "./AdminCoursePreview.vue?vue&type=template&id=84a836e4&scoped=true"
import script from "./AdminCoursePreview.vue?vue&type=script&lang=js"
export * from "./AdminCoursePreview.vue?vue&type=script&lang=js"

import "./AdminCoursePreview.vue?vue&type=style&index=0&id=84a836e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a836e4"]])

export default __exports__